<template>
  <el-form
    label-position="top"
    :model="form"
    :rules="rules"
    ref="form"
    class="text-left"
  >
    <el-row :gutter="30">
      <el-col :span="24" :sm="4">
        <el-form-item label="ลำดับ" prop="number">
          <el-input v-model="form.number"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="8">
        <el-form-item label="หัวข้อบทเรียน" prop="topicName">
          <el-input v-model="form.topicName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12">
        <el-form-item
          prop="topicClip"
          :label="
            form.topicClip == ''
              ? 'แนบคลิปหัวข้อบทเรียน (รองรับไฟล์ .ogg .mp4 .mpg .mpeg .wmv .avi ขนาดไม่เกิน 800 MB)'
              : ''
          "
        >
          <el-upload
            v-if="form.topicClip == ''"
            class="upload-input-text"
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="uploadTopicClip"
          >
            <template slot="trigger">
              <div class="flex-display">
                <el-input v-model="form.topicClip.name" class=""></el-input>
                <el-button type="primary" class="light mg-l-4"
                  >แนบไฟล์</el-button
                >
              </div>
            </template>
          </el-upload>
          <p v-else class="pd-b-4">
            คลิปหัวข้อบทเรียน
            <span class="text-underline color-primary-light"
              >{{
                typeof form.topicClip.name != "undefined"
                  ? form.topicClip.name
                  : form.topicClip.file
              }}
              <i
                @click="delTopicClip"
                class="fas fa-times-circle color-gray-lighter pd-l-5 cursor-pointer"
              ></i
            ></span>
          </p>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12">
        <el-form-item
          label="ระยะเวลาในการเปิด-ปิดหัวข้อ"
          prop="topicDistanceDate"
          class="line-unset"
        >
          <el-date-picker
            v-model="form.topicDistanceDate"
            type="daterange"
            class="width-100 show-in-desktop"
            range-separator="ถึง"
            start-placeholder=""
            end-placeholder=""
            format="d MMMM yyyy"
            :picker-options="{
              disabledDate(time) {
                return (
                  time.getTime() < new Date(startDate).getTime() ||
                  time.getTime() > new Date(endDate).getTime()
                );
              },
            }"
          >
          </el-date-picker>
          <div class="flex-display js-between show-in-desktop">
            <span class="color-gray line-initial text-font-12"
              >เวลา 0.00 น.</span
            >
            <span class="color-gray line-initial text-font-12"
              >เวลา 23.59 น.</span
            >
          </div>

          <el-date-picker
            v-model="form.topicDistanceDate[0]"
            type="date"
            format="d MMMM yyyy"
            class="show-in-mobile width-100"
            :picker-options="{
              disabledDate(time) {
                return (
                  time.getTime() >
                    new Date(form.topicDistanceDate[1]).getTime() ||
                  time.getTime() < new Date(startDate).getTime() ||
                  time.getTime() > new Date(endDate).getTime()
                );
              },
            }"
          >
          </el-date-picker>
          <span class="color-gray line-initial text-font-12 show-in-mobile"
            >เวลา 0.00 น.</span
          >

          <el-date-picker
            v-model="form.topicDistanceDate[1]"
            type="date"
            format="d MMMM yyyy"
            class="show-in-mobile mg-t-4 width-100"
            :picker-options="{
              disabledDate(time) {
                return (
                  time.getTime() <
                    new Date(form.topicDistanceDate[0]).getTime() ||
                  time.getTime() < new Date(startDate).getTime() ||
                  time.getTime() > new Date(endDate).getTime()
                );
              },
            }"
          >
          </el-date-picker>
          <span class="color-gray line-initial text-font-12 show-in-mobile"
            >เวลา 23.59 น.</span
          >
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="เนื้อหาหัวข้อ">
          <yimo-vue-editor
            v-model="form.topicDescription"
            @input="clearText(form.topicDescription)"
          ></yimo-vue-editor>
        </el-form-item>
      </el-col>
    </el-row>

    <div class="text-center pd-y-3">
      <el-button
        v-if="type == 'add'"
        @click="createTopic"
        type="primary"
        round
        class="pd-x-1"
        >เพิ่มหัวข้อ</el-button
      >
      <el-button
        v-if="type == 'update'"
        @click="updateTopic"
        type="primary"
        round
        class="pd-x-1"
        >บันทึก</el-button
      >
    </div>
  </el-form>
</template>

<script>
import { isFileVideo, isFileAudio } from "@/service/file";
import { clearText } from "@/service/editor";

export default {
  props: {
    type: {
      type: String,
      default() {
        return "add";
      },
    },
    topic: {
      type: Object,
      default() {
        return null;
      },
    },
    startDate: {
      type: String,
      default() {
        return "";
      },
    },
    endDate: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      form: {
        topicName: "",
        topicClip: "",
        topicDistanceDate: [],
        topicDescription: "",
        number: "",
      },
      rules: {
        topicName: [
          {
            required: true,
            message: "กรุณากรอกหัวข้อบทเรียน",
            trigger: "blur",
          },
        ],
        topicDistanceDate: [
          {
            required: true,
            message: "กรุณาเลือกระยะเวลาในการเปิด-ปิดหัวข้อ",
            trigger: ["blur", "change"],
          },
        ],
        topicClip: {
          required: true,
          message: "กรุณาเลือกไฟล์วิดีโอ",
        },
        number: [
          {
            required: true,
            message: "กรุณากรอกลำดับหัวข้อบทเรียน",
            trigger: "blur",
          },
        ],
      },
      topicClipDel: "",
      topicId: "",
    };
  },
  watch: {
    topic() {
      this.setTopic();
    },
  },
  mounted() {
    this.setTopic();
  },
  methods: {
    setTopic() {
      if (this.topic != null) {
        this.form = {
          topicName: this.topic.topic,
          topicClip:
            typeof this.topic.attach.file != "undefined"
              ? this.topic.attach
              : "",
          topicDistanceDate:
            typeof this.topic.durationTime != "undefined" &&
            this.topic.durationTime.open
              ? [this.topic.durationTime.open, this.topic.durationTime.close]
              : [],
          topicDescription: this.topic.detail,
          number: this.topic.index,
        };
        this.topicId = this.topic._id;
      }
    },
    createTopic() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("createTopic", this.form);
        }
      });
    },
    updateTopic() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let obj = {
            topicClipDel: this.topicClipDel,
          };
          this.$emit("updateTopic", this.form, obj, this.topicId);
        }
      });
    },
    uploadTopicClip(file) {
      var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      if (
        !this.isFileVideo(file.raw.type) &&
        !this.isFileAudio(file.raw.type)
      ) {
        this.$message.error("ไม่รองรับไฟล์ที่อัพโหลด");
      } else if (sizeInMB > 800) {
        this.$message.error("ไฟล์ที่อัพโหลดขนาดใหญ่เกินกว่าที่รองรับ");
      } else {
        this.form.topicClip = file;
        this.rules.topicClip.required = false;
      }
    },
    delTopicClip() {
      this.rules.topicClip.required = true;
      if (typeof this.form.topicClip.name == "undefined") {
        this.topicClipDel = this.form.topicClip.file;
      }

      this.form.topicClip = "";
    },
  },
};
</script>

<style scoped></style>
